// removed by extract-text-webpack-plugin
module.exports = {"survey-dates":"SurveyDate__survey-dates___2Uw8x"};